import { StatusIndicator } from '@amzn/awsui-components-react';
import React, { useMemo } from 'react';

export default function TaskStatusIndicator(props: {status: string}) {
    const { status = '' } = props;

    const getStatusIcon = () => {
        switch (status) {
            case 'Overdue':
            case 'Due soon': return 'warning';
            case 'In Progress': return 'in-progress';
            case 'Pending': return 'pending';
            case 'Complete': return 'success';
            default: return null;
        }
    }

    const getColorOverride = () => {
        switch(status){
            case 'Overdue': return 'red';
            case 'Due soon': return 'yellow'
            default: return undefined;
        }
    }
    
    const statusIcon = useMemo(getStatusIcon, [status]);
    const colorOverride = useMemo(getColorOverride, [status]);

    return  statusIcon == null
            ?
                <span>{status || ' '}</span>
            :
                <StatusIndicator type={statusIcon} colorOverride={colorOverride}>{status}</StatusIndicator>;
}